const STORAGE_KEY = 'studioBoothPublicAppUrl';

export function normalizePublicAppUrl(value: string | null | undefined): string {
  return (value || '').trim().replace(/\/+$/, '');
}

export function getPublicAppUrl(): string {
  if (typeof window === 'undefined') return '';

  const queryValue = new URLSearchParams(window.location.search).get('publicUrl');
  const normalizedQuery = normalizePublicAppUrl(queryValue);
  if (normalizedQuery) {
    window.localStorage.setItem(STORAGE_KEY, normalizedQuery);
    return normalizedQuery;
  }

  const stored = normalizePublicAppUrl(window.localStorage.getItem(STORAGE_KEY));
  return stored || window.location.origin;
}

export function setPublicAppUrl(value: string): string {
  if (typeof window === 'undefined') return '';

  const normalized = normalizePublicAppUrl(value);
  if (normalized) {
    window.localStorage.setItem(STORAGE_KEY, normalized);
    return normalized;
  }

  window.localStorage.removeItem(STORAGE_KEY);
  return window.location.origin;
}
